import { baseRoutes } from "helpers/baseRoutes";

const userRouteMap = {
  LOGIN: { path: `${baseRoutes.userBaseRoutes}/` },
  LANDING: { path: `${baseRoutes.userBaseRoutes}/categories` },
  MEETINGFLOORPLAN: { path: `${baseRoutes.userBaseRoutes}/categories/floor-plan` },
  FLOORPLANCOMPARE: { path: `${baseRoutes.userBaseRoutes}/categories/floor-plan-compare` },
  MODELGALLERY: { path: `${baseRoutes.userBaseRoutes}/categories/model-gallery` },
  AMENITIES_FILM: {
    path: `${baseRoutes.userBaseRoutes}/categories/amenities-display/amenities-film`,
  },
  GALLERY: {
    path: `${baseRoutes.userBaseRoutes}/categories/amenities-display/amenities-gallery`,
  },
  AMENITIESDISPLAY: { path: `${baseRoutes.userBaseRoutes}/categories/amenities-display` },
  AMENITIESMODEL: { path: `${baseRoutes.userBaseRoutes}/categories/amenities-model` },
  MEETINGROOM: { path: `${baseRoutes.userBaseRoutes}/categories/meeting-room` },
  PRIVATESHOWING: { path: `${baseRoutes.userBaseRoutes}/categories/private-showing-(web)`},
  LOUNGEROOM: { path: `${baseRoutes.userBaseRoutes}/categories/lounge-room` },
  AMENITIES_MODEL_FLOORS: {
    path: `${baseRoutes.userBaseRoutes}/categories/amenities-model-floors`,
  },
  AMENITIESMODELUPPER: {
    path: `${baseRoutes.userBaseRoutes}/categories/amenities-model-upper`,
  },
  AMENITIESMODELLOWER: {
    path: `${baseRoutes.userBaseRoutes}/categories/amenities-model-lower`,
  },
  AMENITIESMODELGROUND: {
    path: `${baseRoutes.userBaseRoutes}/categories/amenities-model-ground`,
  },
  GREATROOM: { path: `${baseRoutes.userBaseRoutes}/categories/great-room` },
};
export default userRouteMap;
